import { today } from "@repo/helpers";
import { Loading } from "@repo/ui";
import { useEffect, useState } from "react";

import type { Rep, RepDiscipline } from "../../../../models";

import {
	RepDisciplinesProvider,
	RepProvider,
	useRepContext,
	useRepDisciplineContext,
} from "../../../../contexts/editableItemContext";
import { PendingChangesProvider } from "../../../../contexts/pendingChangesContext";
import { RepDisciplineReason } from "../../../../models/repDiscipline";
import RepDisciplineEditorDynamic from "../../../disciplines/editor";

export function RepDisciplineEditorModal(props: Props) {
	const { rep, onClose } = props;
	return (
		<PendingChangesProvider>
			<RepProvider item={{ ...rep }}>
				<RepDisciplinesProvider>
					<RepDisciplineEditorModalInternal {...props} onClose={onClose} />
				</RepDisciplinesProvider>
			</RepProvider>
		</PendingChangesProvider>
	);
}

interface Props {
	rep: Rep;
	incidentId: number;
	onModalSave: () => Promise<void>;
	onClose: () => void;
}

export function RepDisciplineEditorModalInternal(props: Props) {
	const { incidentId, onModalSave, onClose } = props;

	const { item: repDiscipline, overwriteItem } = useRepDisciplineContext();
	const { repId } = useRepContext();

	const [isLoading] = useState(false);

	//Always a new discipline; ones already added from this incident are edited on the Disciplines tab
	useEffect(() => {
		overwriteItem({
			startDate: today(),
			representativeId: repId,
			repIncidentId: incidentId,
			reason: RepDisciplineReason.Complaint,
			reasonId: RepDisciplineReason.Complaint,
		} as RepDiscipline);
	}, [overwriteItem, repId, incidentId]);

	async function postSave() {
		await onModalSave();
		onClose();
	}

	return (
		<Loading loading={isLoading || !repDiscipline}>
			<RepDisciplineEditorDynamic postSave={postSave} />
		</Loading>
	);
}
